import { __ } from "@wordpress/i18n";
import { ReactComponent as AngleRight } from "../assets/angle_right.svg";
import { ReactComponent as Times } from "../assets/times.svg";
import { ReactComponent as Rocket } from "../assets/rocket.svg";
import { ReactComponent as Update } from "../assets/updates.svg";
import { ReactComponent as Loader } from "../assets/loader.svg";
import { ReactComponent as Support } from "../assets/support.svg";
import { ajaxCall } from "../Helpers/AjaxHelper";
import { useRef, useState } from "react";
import Modal from "react-modal";

const customStyles = {
  content: {
    inset: "inherit",
    borderTop: "5px solid #D72C2C",
    boxShadow:
      "0px 26.7377px 77.2886px rgb(0 0 0 / 11%), 0px 14.2952px 41.3222px rgb(0 0 0 / 9%), 0px 8.01379px 23.1649px rgb(0 0 0 / 8%), 0px 4.25607px 12.3027px rgb(0 0 0 / 6%), 0px 1.77104px 5.11942px rgb(0 0 0 / 4%)",
    overflowY: "auto",
    padding: "55px 50px",
    postion: "relative",
    boxSizing: "border-box",
    top: "50%",
    left: "80px",
    width: "1166px",
    maxWidth: "calc(100% - 250px)",
    maxHeight: "80vh",
  },
};

Modal.setAppElement("#sby-settings");

const LicenseActionButton = ({
  isLicenseActive,
  licenseField,
  setLicenseStatus,
  setLicenseData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <button
      onClick={() => {
        setIsLoading(true);
        ajaxCall(
          isLicenseActive()
            ? "sby_license_deactivation"
            : "sby_license_activation",
          {
            license_key: licenseField.current.value,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(({ data }) => {
            setLicenseStatus(data.licenseStatus);
            setLicenseData(data.licenseData);
            window.sby_settings.licenseData = data.licenseData;
          })
          .finally(() => {
            setIsLoading(false);
          });
      }}
      type="button"
      className={`sby-btn sb-btn-default sb-btn-license-activate ${
        !isLicenseActive() ? "sb-btn-blue" : "sb-btn-grey"
      } ${isLicenseActive() && isLoading ? "loading" : ""}`}
    >
      {isLoading && <Loader />}
      {!isLicenseActive()
        ? __("Activate", "feeds-for-youtube")
        : __("Deactivate", "feeds-for-youtube")}
    </button>
  );
};

const LicenseNotice = () => {
  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);
  const licenseFieldRef = useRef();
  const [licenseStatus, setLicenseStatus] = useState(
    window.sby_settings.licenseStatus
  );
  const [licenseData, setLicenseData] = useState(
    window.sby_settings.licenseData
  );
  const [licenseKey] = useState(window.sby_settings.licenseKey);

  const isLicenseActive = () => {
    return (
      licenseStatus === "valid" ||
      licenseStatus === "active" ||
      licenseStatus === "activated"
    );
  };

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div
      id="sby-license-expired-agp"
      className="sby-license-expired-agp sby-le-flow-1"
    >
      <span className="sby-license-expired-agp-message">
        {__(
          "Your YouTube Feed Pro License has expired. Renew to keep using PRO features.",
          "feeds-for-youtube"
        )}
        <span onClick={openModal}>{__("Learn More", "feeds-for-youtube")}</span>
      </span>
      <button
        type="button"
        id="sby-dismiss-header-notice"
        title="Dismiss this message"
        data-page="overview"
        className="sby-dismiss"
      >
        <Times />
      </button>
      <div>
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="sbc-popup-cls" onClick={closeModal}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#141B38"
              />
            </svg>
          </div>
          <div>
            <div className="sb-llm-header">
              <h2>Your YouTube Feed Pro License is inactive</h2>
              <p>No license key detected. With a license key you can: </p>
            </div>
            <div className="sb-llm-upgrade-benefits">
              <div className="sb-benefits-block">
                <span className="sb-icon">
                  <Rocket />
                </span>
                <h4>Use any Pro features</h4>
                <p>
                  New and existing feeds will not yet allow the use of the
                  premium feed types and enhanced display settings available in
                  pro.
                </p>
              </div>
              <div className="sb-benefits-block">
                <span className="sb-icon">
                  <Update />
                </span>
                <h4>Recieve Critical Updates</h4>
                <p>
                  With changes to YouTube and WordPress it's critical to keep
                  your plugin up to date. We regularly provide fixes and
                  enhancements in new releases
                </p>
              </div>

              <div className="sb-benefits-block">
                <span className="sb-icon">
                  <Support />
                </span>
                <h4>Receive technical support</h4>
                <p>
                  We have a team of WordPress experts ready to help you if
                  anything goes wrong. Keep your feeds up and running just how
                  you need.
                </p>
              </div>
            </div>
            <div className="sb-llm-license-key-block">
              <div className="sb-license-checker-form">
                <div className="sb-left">
                  <h3>Have a license key?</h3>
                  <p>You can activate it by adding it here</p>
                </div>
                <div className="sb-right">
                  <div className="sb-modal-license-key-form">
                    <div className="sb-form-field">
                      <input
                        ref={licenseFieldRef}
                        type="password"
                        name="license-key"
                        id="license-key"
                        className="sb-input sby-form-field"
                        defaultValue={licenseKey}
                        placeholder={__(
                          "Paste license key here",
                          "feeds-for-youtube"
                        )}
                      />
                      {licenseStatus === "valid" && (
                        <span className="field-icon fa fa-check-circle" />
                      )}
                      {licenseData.errorMsg && (
                        <span className="field-icon field-icon-error fa fa-times-circle" />
                      )}
                    </div>
                    <LicenseActionButton
                      isLicenseActive={isLicenseActive}
                      licenseField={licenseFieldRef}
                      setLicenseStatus={setLicenseStatus}
                      setLicenseData={setLicenseData}
                    />
                  </div>
                </div>
              </div>
              <div className="sb-llm-lk-footer">
                <p>
                  <span>Need a New License? </span>
                  <a
                    href="https://smashballoon.com/pricing/youtube-feed"
                    target="_blank"
                  >
                    Buy a License
                    <AngleRight />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default LicenseNotice;
